<template>
    <div class="operations">
        <Header>{{ $t('messages.operations.header') }}</Header>
        <v-container>
            <v-row dense>
                <v-col cols="12">
                     <v-text-field
                        :label="searchLabel"
                        prepend-inner-icon="mdi-magnify"
                        v-model="search"
                        flat
                        solo
                        dense 
                        hide-details
                        @input="searchOperation"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" v-for="projet in this.projets" v-bind:key="projet.id_projet">
                    <v-card outlined @click='goToProject(projet.code_projet)'>
                        <v-row align="center" class="pa-1" dense>
                            <v-col cols="4">
                                <div class="type">
                                    {{projet.type.libelle}}
                                </div>
                            </v-col>
                            <v-col cols="7">
                                <div>
                                    <h3>
                                        {{projet.nom}}
                                    </h3>
                                    <div class="dateEvent">
                                        Du {{projet.date_debut}} au {{projet.date_fin}}
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="1">
                                <i class="mdi mdi-chevron-right"></i>
                            </v-col>
                        </v-row>
                       
                        
                    </v-card>
                    
                </v-col> 
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Header from '@/components/Header'
export default {
  name: 'Operations',
  components: {
    Header,
  },
  data() {
    return {
      search: "",
      projets: [],
    }
  },
  methods: {
    goToProject(codeProjet){
        this.$store.dispatch('setLoader', true)
        this.$store.dispatch('getLeadProjets', {codeProjet: codeProjet}).then(() => {
            this.$store.dispatch('getNotifs', {id_utilisateur: this.$store.state.user.id, code_projet : codeProjet}).then((e) => {
                this.$store.dispatch('getMedias', {id_utilisateur: this.$store.state.user.id, code_projet : codeProjet}).then((e) => {
                    this.$store.dispatch('getStatistiques', {codeProjet : codeProjet}).then(() => {
                        this.$store.dispatch('setLoader', false)
                        this.$router.push({ name: 'Todo', params: { code: codeProjet } })
                    })
                })
                
            }) 
        }) 
    },
    searchOperation(){
        if(this.search.length > 2){
            let ids = [];
            this.projets.forEach((element, index) => {
                let nom = element.nom.toLowerCase()
                let type = element.type.libelle.toLowerCase()
                if(!nom.includes(this.search.toLowerCase()) && !type.includes(this.search.toLowerCase())){
                    this.projets.splice(index, 1);
                }
            })
        } else {
           this.projets = Object.assign([], this.$store.state.projets)
        }
    }
  },
  computed: {
    searchLabel: function(){
        return this.$t('messages.operations.label')
    }
  },
  watch: {
    
  },
  created() {
    this.$store.dispatch('setLoader', false)
    if(Object.keys(this.$store.state.projets).length === 0){
        this.$store.dispatch('setLoader', true).then((e) => {
            this.$store.dispatch('getProjets', {}).then((e) => {
                this.projets = this.$store.state.projets;
            })
        })
    } else {
        this.projets = this.$store.state.projets;
    } 
    this.$store.dispatch('clearLeads', {})
    OneSignal.push(function() {
       OneSignal.isPushNotificationsEnabled(function(isEnabled) {
        if (isEnabled)
          console.log("Push notifications are enabled!");
        else
          console.log("Push notifications are not enabled yet.");    
          OneSignal.showNativePrompt();
      });
    });


  },
}
</script>

<style lang="scss">
.operations {
    padding-top:10vh;
    .type {
        font-size:0.8em;
        text-align: center;
        margin: 0 12px;
        padding:5px 2px;
        background-color: #62d59d;
        border-radius:5px;
        color:white;
    }   
    .dateEvent {
        font-size:0.8em;
    }
    i {
        font-size:1.4em;
    }
}
    
</style>